(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfTopBuffer', [
    '$window', function($window) {
      return {
        restrict: 'A',
        link: (function(_this) {
          return function(scope, elem, attrs) {
            var resizeit;
            resizeit = function() {
              var top;
              top = parseInt(App.sidebar.element.outerHeight()) - parseInt(attrs.mfTopBuffer) + 120;
              return angular.element(elem).css('top', top);
            };
            resizeit();
            return angular.element($window).bind('resize', debounce(function() {
              return resizeit();
            }));
          };
        })(this)
      };
    }
  ]);

}).call(this);
